import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { Input } from '@angular/core';

@Directive({
  selector: '[appDatepicker]',
})
export class DatepickerDirective {
  @Input() datePickerMask: string;

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (isNaN(parseInt(event.key))) {
      return false;
    } else {
      return true;
    }
  }

  @HostListener('focusout', ['$event.target.value'])
  onBlur(value: string) {
    this.elRef.nativeElement.value = 'Hello';
  }
}
